import type { FlatSysV2 } from 'services/cms/typesUtil';

interface IEntryDataAttributes {
  'data-entry-id'?: string;
  'data-field'?: string;
  'data-content-type'?: string;
}

export function getEntryDataAttributes<T extends FlatSysV2 & { field?: string }>(
  entry?: T,
): IEntryDataAttributes | undefined {
  if (!entry) return;

  const { id, contentType, field } = entry;
  const dataAttributes = {};

  if (field) {
    dataAttributes['data-field'] = field;
  }
  if (id) {
    dataAttributes['data-entry-id'] = id;
  }
  if (contentType) {
    dataAttributes['data-content-type'] = contentType;
  }

  return dataAttributes;
}
